import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    M.FormSelect.init(this.element.querySelectorAll('select'), {
      dropdownOptions: {
        container: document.body
      }
    })
  }

  disconnect() {
    if (Array.isArray(this.instances)) {
      this.instances.forEach(instance => {
          // Guard against undefined/null instances
          if (instance && typeof instance.destroy === 'function') {
              instance.destroy();
          }
      });
    }

    // Optional: reset the array to help GC
    this.instances = [];

    // this.instances.forEach(instance => {
    //   instance.destroy();
    // });
  }
}
